module.exports = __webpack_public_path__ + "media/images/logo_blockchain-5950287ff4601c9b29914a83e0ff1b9e.png";